
const ReserveResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	// "result": {}
    "tktTimeLimit": "string",
    "category": 0,
    "gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    "reserveCode": "string",
    "name": "string",
    "lastName": "string",
    "nationalID": "string",
    "phoneNumber": "string",
    "email": "string",
    "mobile": "string",
    "adultCount": 0,
    "childCount": 0,
    "infantCount": 0,
    "providerName": "string",
    "statusCode": 100
	
};
 

  export default ReserveResponse;
  